import styled from 'styled-components'

import { colors, textStyles } from '../../theme'
import { Header as HeaderC, Link } from '../../components'

export const HomeTemplate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${colors.pureWhite};
  color: ${colors.pureBlack};
  width: 100vw;
  height: 100vh;
  padding-top: 6rem;
`

export const Header = styled(HeaderC)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
`

export const Title = styled.h1`
  ${textStyles.titleH1};
  margin-top: 4.8rem;
  margin-bottom: 2.5rem;
`

export const Text = styled.div`
  ${textStyles.text};
  text-align: justify;
  margin: 0 1rem;
  max-width: 64rem;

  h2 {
    ${textStyles.titleH3};
  }

  p {
    margin-bottom: 0.5rem;
    word-break: break-word;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }
`

export const Text2 = styled(Text)`
  font-size: 1.2rem;
  text-align: center;
  margin-top: 3rem;
`

export const ButtonLink = styled(Link)`
  display: inline-flex;
  margin-top: 5.5rem;
`
